<template>
  <div class="search">
    <HearderTitle name="详细查询" />
    <div class="tableBox">
      <div class="tool_bar">
        <el-form :inline="true" :model="queryInfo">
          <el-form-item> <el-input v-model="queryInfo.cv" placeholder="员工名/手机号"></el-input></el-form-item>
          <el-form-item style="margin-left: -10px">
            <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="search()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <el-table ref="refTable" header-cell-class-name="h_bg" :data="tableData" style="width: 100%">
          <el-table-column prop="pername" label="姓名" width="70" align="center"> </el-table-column>
          <el-table-column prop="dep_id" label="部门" align="center"> </el-table-column>
          <el-table-column prop="roles" label="职位" align="center"> </el-table-column>
          <el-table-column prop="sex" label="性别" align="center"> </el-table-column>
          <el-table-column prop="province" label="籍贯" align="center"> </el-table-column>
          <el-table-column prop="birthday" label="生日" align="center"> </el-table-column>
          <el-table-column prop="contact" width="158" label="手机号" align="center"> </el-table-column>
          <el-table-column prop="cardid" width="200" label="身份证号" align="center"> </el-table-column>
          <el-table-column prop="inday" label="入职日期" align="center"> </el-table-column>
          <el-table-column prop="prepactday" label="合同到期" align="center"> </el-table-column>
          <el-table-column prop="stu" label="状态" align="center"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  // import { search } from '@/api/audition.js'
  import HearderTitle from '@/components/HearderTitle'
  export default {
    name: 'search',
    data() {
      return {
        queryInfo: {
          // 渠道
          cv: '',
        },
        tableData: [],
        total: 0,
      }
    },
    created() {
      this.search()
    },
    components: { HearderTitle },
    methods: {
      // 获取人员列表
      async search() {
        let { list } = await search(this.queryInfo)
        this.tableData = list
      },
    },
  }
</script>

<style lang="less">
  .search {
    .tableBox {
      .select {
        color: #015293;
        font-size: 12px;
        cursor: pointer;
      }
      .tool_bar {
        padding-top: 28px;
        padding-bottom: 18px;
        font-size: 14px;
        color: #888;
        .el-form-item {
          margin-right: 20px;
          margin-bottom: 0;
          .el-input__inner {
            width: 210px;
            height: 32px;
          }
          .el-input__inner {
            padding-left: 10px;
          }
          .middle {
            padding: 0 10px;
          }
          .searchBtn {
            width: 82px;
          }
        }
      }
      .el-table {
        min-height: 685px;
        &::before {
          height: 0;
        }
      }
    }
  }
  .auditionDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding-bottom: 0;
      overflow: hidden;
      .el-form-item {
        margin-bottom: 15px;
      }
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-textarea__inner {
      width: 178px;
    }
    .el-input__inner {
      padding-left: 15px;
      width: 178px;
    }
    .searchBtn {
      width: 112px;
    }
  }
  .uploadDialog {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
    }
    .el-form {
      .el-form-item {
        &:last-child {
          margin-bottom: 0;
          .el-button {
            float: right;
            width: 112px;
            height: 32px;
            padding: 0;
            text-align: center;
          }
        }
      }
    }
  }
</style>
